import * as actionsTypes from './actions';

const initialState = {
    isLoading: false,
    allElectricians: {},
    electrician: {},
    electricianAgentsForTable: {},
    electricianAgentsIsLoading: false,
    allAggregators: {},
    eleAgentDevicesForTable: {},
    eleAgentDevicesIsLoading: false
}

export default function (state = { ...initialState }, action) {
    switch (action.type) {

        case actionsTypes.GET_ALL_ELECTRICIANS_REQUEST:
            return { ...state, isLoading: true }

        case actionsTypes.GET_ALL_ELECTRICIANS_SUCCESS:
            return { ...state, isLoading: false, allElectricians: action.payload || {} }

        case actionsTypes.GET_ALL_ELECTRICIANS_FAILED:
            return { ...state, isLoading: false }

        case actionsTypes.GET_ELECTRICIAN_BY_ID_REQUEST:
            return { ...state, isLoading: true }

        case actionsTypes.GET_ELECTRICIAN_BY_ID_SUCESS:
            return { ...state, isLoading: false, electrician: action.payload || {} }

        case actionsTypes.GET_ELECTRICIAN_BY_ID_FAILED:
            return { ...state, isLoading: false }

        case actionsTypes.GET_ELECTRICIAN_AGENT_FOR_TABLE_REQUEST:
            return { ...state, electricianAgentsIsLoading: true }

        case actionsTypes.GET_ELECTRICIAN_AGENT_FOR_TABLE_SUCCESS:
            return { ...state, electricianAgentsIsLoading: false, electricianAgentsForTable: action.payload || {} }

        case actionsTypes.GET_ELECTRICIAN_AGENT_FOR_TABLE_FAILED:
            return { ...state, electricianAgentsIsLoading: false }

        case actionsTypes.DELETE_ELECTRICIAN_REQUEST:
            return { ...state, isLoading: true }

        case actionsTypes.DELETE_ELECTRICIAN_SUCCESS:
            return { ...state, isLoading: false }

        case actionsTypes.DELETE_ELECTRICIAN_FAILED:
            return { ...state, isLoading: false }

        case actionsTypes.UPDATE_ELECTRICIAN_REQUEST:
            return { ...state, isLoading: true }

        case actionsTypes.UPDATE_ELECTRICIAN_SUCCESS:
            return { ...state, isLoading: false }

        case actionsTypes.UPDATE_ELECTRICIAN_FAILED:
            return { ...state, isLoading: false }

        case actionsTypes.GET_ALL_AGGREGATORS_LIST_REQUEST:
            return { ...state, isLoading: true }

        case actionsTypes.GET_ALL_AGGREGATORS_LIST_SUCCESS:
            return { ...state, isLoading: false, allAggregators: action.payload || {} }

        case actionsTypes.GET_ALL_AGGREGATORS_LIST_FAILED:
            return { ...state, isLoading: false }

        case actionsTypes.CREATE_ELECTRICIAN_REQUEST:
            return { ...state, isLoading: true }

        case actionsTypes.CREATE_ELECTRICIAN_SUCCESS:
            return { ...state, isLoading: false }

        case actionsTypes.CREATE_ELECTRICIAN_FAILED:
            return { ...state, isLoading: false }

        case actionsTypes.GET_ADMIN_ELECTRICIAN_AGENT_DEVICES_FOR_TABLE_REQUEST:
            return { ...state, eleAgentDevicesIsLoading: true }

        case actionsTypes.GET_ADMIN_ELECTRICIAN_AGENT_DEVICES_FOR_TABLE_SUCCESS:
            return { ...state, eleAgentDevicesIsLoading: false, eleAgentDevicesForTable: action.payload || {} }

        case actionsTypes.GET_ADMIN_ELECTRICIAN_AGENT_DEVICES_FOR_TABLE_FAILED:
            return { ...state, eleAgentDevicesIsLoading: false }

        case actionsTypes.CLEAR_ADMIN_ELECTRICIAN_DATA:
            return { ...state, ...initialState }

        default:
            return state

    }
}